import { Controller } from "@hotwired/stimulus"

// WordPress投稿オプション選択モーダル用
// ユーザーの選択内容に応じて非表示のフォームの値（include_image）を動的に変更し、フォーム送信処理を実行します。
// モーダルのUIおよび送信フローはViewComponentと連携して実装されています。
export default class extends Controller {
  static targets = ["postOption", "submitButton", "form", "includeImagesField"]

  declare readonly postOptionTargets: HTMLInputElement[]
  declare readonly submitButtonTarget: HTMLButtonElement
  declare readonly formTarget: HTMLFormElement
  declare readonly includeImagesFieldTarget: HTMLInputElement

  submit(): void {
    const selectedOption = this.postOptionTargets.find(option => option.checked)

    if (selectedOption) {
      const includeImages = selectedOption.value === 'with_images'
      this.includeImagesFieldTarget.value = includeImages ? 'true' : 'false'
      this.formTarget.submit()
    }
  }
}
